import ApiFile from "@rmp/core/api/types/storage/apiFile";
import BaseStorageController from "@rmp/core/api/base/baseStorageController";
import AbortService from "@rmp/core/services/abortService";
import { ApiHostFileMeta } from "@rmp/api-filestorage";

// API принимает base64-строку, хотя Swagger помечает поле подписи как binary.
const castSignatureToGeneratedType = (signature: string): File => signature as unknown as File;

export class StorageController extends BaseStorageController {
	constructor(abortService: AbortService) {
		super(abortService);
	}
	
	/**
	 * Эндпоинты выдачи файлов типизированы автогеном как void — приводим к Blob здесь,
	 * чтобы касты не расползались по вызывающему коду
	 */
	private getBlob = async (request: Promise<{ data: unknown }>): Promise<Blob> => {
		const { data } = await request;
		
		return data as Blob;
	};

	createFile = async (file: ApiFile): Promise<ApiHostFileMeta> => {
		const { data } = file.signature
			? await this.api.file.signedCreate({
				data: file.data,
				name: file.name,
				namespace: file.namespace,
				mimeType: file.mimeType,
				signature: castSignatureToGeneratedType(file.signature)
			})
			: await this.api.file.fileCreate({
				data: file.data,
				name: file.name,
				namespace: file.namespace,
				mimeType: file.mimeType
			});
		
		return data;
	};

	getFile = async (id: string) => {
		return this.getBlob(this.api.file.dataListById(id, { format: "blob" }));
	};

	getFilePreview = async (id: string) => {
		return this.getBlob(this.api.file.previewListById(id, { format: "blob" }));
	};

	getFileMeta = async (id: string) => {
		const { data } = await this.api.file.metaListById(id);
		
		return data;
	};

	signFile = async (id: string, signature: string) => {
		const { data } = await this.api.file.signCreateById(id, {
			signature: castSignatureToGeneratedType(signature)
		});
		
		return data;
	};
	
	downloadSignature = async (id: string, fileName: string) => {
		return this.getBlob(this.api.file.signatureListById({ id, fileName }, { format: "blob" }));
	};
	
}
